$(function(){
  window.IS_FOCUSED = true
  $(window).on("focus", function(){
    window.IS_FOCUSED = true
  })

  $(window).on("blur", function(){
    window.IS_FOCUSED = false
  })
})